export default { 
    getUltimasChamadas: state => state.chamadas
}



// WEBPACK FOOTER //
// ./src/store/modules/protaxi/getters.js